import React from "react";
import {
  Form,
  Select,
  Row,
  Col,
  Button,
  Radio,
  AutoComplete,
  Input
} from "antd";
import moment from "moment";
import DayPicker from "react-day-picker";
import dateFormat from "dateformat";
import "react-day-picker/lib/style.css";
import NumericInput from "../../../helpers/NumericInput";

import { strings, openNotificationWithIcon } from "../../../helpers";

const FormItem = Form.Item;
const { TextArea } = Input;
const RadioGroup = Radio.Group;
const { Option } = Select;

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();
const fromMonth = new Date(1900, 0);
const toMonth = new Date(currentYear, currentMonth);

/**
 * @function YearMonthForm
 * @desc This method shows years and months in daypicker
 */
function YearMonthForm({ date, localeUtils, onChange }) {
  const months = localeUtils.getMonths();

  const years = [];
  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i);
  }

  const handleChange = e => {
    const year = e.target.form.Years.value;
    const month = e.target.form.Months.value;
    onChange(new Date(year, month));
  };

  return (
    <span className="DayPicker-Caption">
      <select
        name={strings.month}
        onChange={handleChange}
        value={date.getMonth()}
        className="ml-10"
      >
        {months.map((month, i) => (
          <option key={month} value={i}>
            {month}
          </option>
        ))}
      </select>
      <select
        name={strings.year}
        onChange={handleChange}
        value={date.getFullYear()}
        className="ml-10"
      >
        {years.map(year => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </span>
  );
}

export default class BasicInfoView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      month: toMonth,
      isDatePicker: false,
      selectedDay: null
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  /**
   * @function setWrapperRef
   * @desc This method sets reference to date picker
   */
  setWrapperRef = node => {
    this.wrapperRef = node;
  };

  /**
   * @function getOptions
   * @returns Array of Options
   * @description Returns specialities list as options
   */
  getOptions = () => {
    const { specialities } = this.props;
    return specialities.map(speciality => (
      <Option
        key={speciality.name}
        value={speciality.name}
        // doctors={doctors}
        label={speciality.name}
      >
        {speciality.name}
      </Option>
    ));
  };

  /** *
   * @function handleDobClick
   * @desc This method handles date picker click
   */
  handleDobClick = () => {
    const { isDatePicker } = this.state;
    this.setState({
      isDatePicker: !isDatePicker
    });
  };

  /**
   * @function handleYearMonthChange
   * @param date
   * @description handle year or month selection on calendar
   * and get appointments for updated date
   */
  handleYearMonthChange = month => {
    this.setState({ month });
  };

  /**
   * @function handleDayChange
   * @param "day"
   * @description handle day change
   */
  handleDayChange = (day, modifiers = {}) => {
    if (modifiers.disabled) {
      return;
    }
    this.setState(
      {
        day: day.toISOString(),
        isDatePicker: !this.state.isDatePicker,
        selectedDay: day
      },
      () => {
        this.props.updateSelectedDate(day);
      }
    );
  };

  /**
   * @function validateGender
   * @param rule
   * @param value
   * @param callback
   * @desc This method validates the clinic name
   */
  validateGender = (rule, value, callback) => {
    if (!value) {
      callback(`${strings.tickets.gender} ${strings.profile.isRequired}`);
    }
    callback();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const {
      handleSubmit,
      handleSpecialitySearch,
      profileDetail,
      goToNextTab,
      showMedicalRegPhoto,
      showVerifyModal,
      showVerify
    } = this.props;

    const { selectedDay, isDatePicker } = this.state;
    const prefixSelector = getFieldDecorator("countryCode", {
      initialValue: "91"
    })(<span>+91</span>);

    let day = null;
    if (this.props.dob) {
      day = dateFormat(this.props.dob, "dd mmm, yyyy");
    } else if (profileDetail && profileDetail.dob) {
      day = dateFormat(profileDetail.dob, "dd mmm, yyyy");
    }

    //  reg number, dob, educatio, exp bio are optional
    return (
      <div className="kc-block white-bg with-box-shadow round-borders-4x p-20">
        <Row gutter={14} type="flex">
          <Col span={24}>
            <div className="light-bg round-5x p-15 eq-column">
              {/* Basic info: name, number, speciality, reg number, gender, patient per
        hour, dob, exp(in years), bio, add multiple educations (free text) */}
              <Form onSubmit={handleSubmit} layout="vertical">
                <Row type="flex" justify="end">
                  <Col span={4} className="text-right">
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => showVerifyModal()}
                    >
                      {showVerify
                        ? `${strings.ticket_detail_view.Unverify}`
                        : strings.ticket_detail_view.Verify}
                    </Button>
                  </Col>
                </Row>
                <Row type="flex" gutter={16}>
                  <Col span={8}>
                    <FormItem label={strings.profile.doctorName}>
                      {getFieldDecorator("name", {
                        valuePropName: "value",
                        initialValue: profileDetail.name || "",
                        rules: [
                          {
                            required: true,
                            message: `${strings.profile.doctorName} ${strings.profile.isRequired}`
                          }
                        ]
                      })(<Input />)}
                    </FormItem>
                  </Col>
                  <Col span={8}>
                    <FormItem label={strings.tickets.phone_number}>
                      {getFieldDecorator("phoneNumber", {
                        initialValue: profileDetail.phone_number || "",
                        rules: [
                          {
                            required: true,
                            message: `${strings.tickets.phone_number} ${strings.profile.isRequired}`
                          }
                        ]
                      })(
                        <NumericInput
                          addonBefore={prefixSelector}
                          maxLength={10}
                        />
                      )}
                    </FormItem>
                  </Col>

                  <Col span={3}>
                    <FormItem label={strings.profile.dateOfBirth}>
                      <Button
                        onClick={this.handleDobClick}
                        size="small"
                        className="dob-btn"
                      >
                        {day !== null ? day : "dd mmm, yyyy"}
                      </Button>

                      {isDatePicker ? (
                        <div ref={this.setWrapperRef}>
                          <DayPicker
                            disabledDays={[
                              {
                                after: new Date()
                              }
                            ]}
                            initialMonth={new Date()}
                            selectedDays={selectedDay}
                            className="dayPickerCustomBottom"
                            enableOutsideDaysClick
                            month={this.state.month}
                            fromMonth={fromMonth}
                            toMonth={toMonth}
                            onDayClick={this.handleDayChange}
                            captionElement={({ date, localeUtils }) => (
                              <YearMonthForm
                                date={date}
                                localeUtils={localeUtils}
                                onChange={this.handleYearMonthChange}
                              />
                            )}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </FormItem>
                  </Col>
                  <Col span={5}>
                    <FormItem label={strings.tickets.gender}>
                      {getFieldDecorator("gender", {
                        rules: [
                          {
                            required: true,
                            // message: `${strings.tickets.gender} ${
                            //   strings.profile.isRequired
                            // }`,
                            validator: this.validateGender
                          }
                        ],
                        initialValue:
                          profileDetail &&
                          profileDetail.gender != null &&
                          profileDetail.gender
                      })(
                        <RadioGroup>
                          <Radio value="Male">{strings.tickets.male}</Radio>
                          <Radio value="Female">{strings.tickets.female}</Radio>
                        </RadioGroup>
                      )}
                    </FormItem>
                  </Col>
                </Row>

                <Row type="flex" gutter={16}>
                  <Col span={8}>
                    <FormItem
                      label={
                        <span>
                          {strings.profile.registrationNumber}&nbsp;
                          <a
                            href="javascript:;"
                            onClick={showMedicalRegPhoto}
                            className={
                              profileDetail &&
                              profileDetail.reg_photo_url != null &&
                              profileDetail.reg_photo_url
                                ? "view-license-link"
                                : "view-license-link disabled-link"
                            }
                          >
                            ({strings.ticket_detail_view.ClickToView})
                          </a>
                        </span>
                      }
                    >
                      {getFieldDecorator("registrationNumber", {
                        initialValue: profileDetail.reg_nbr || ""
                      })(<Input />)}
                    </FormItem>
                  </Col>
                  <Col span={4}>
                    <FormItem label={strings.profile.patientsPerHour}>
                      {getFieldDecorator("patientsPerHour", {
                        initialValue: profileDetail.patients_per_hour,
                        rules: [
                          {
                            required: true,
                            message: `${strings.profile.patientsPerHour} ${strings.profile.isRequired}`
                          }
                        ]
                      })(<NumericInput />)}
                    </FormItem>
                  </Col>
                  <Col span={4}>
                    <FormItem label={strings.profile.experience}>
                      {getFieldDecorator("experience", {
                        initialValue: profileDetail.exp
                      })(<NumericInput />)}
                    </FormItem>
                  </Col>

                  <Col span={8}>
                    <FormItem label={strings.ticket_detail_view.speciality}>
                      {getFieldDecorator("speciality", {
                        rules: [
                          {
                            required: true,
                            message: `${strings.ticket_detail_view.speciality} ${strings.profile.isRequired}`
                          }
                        ],
                        initialValue: profileDetail.speciality
                      })(
                        <AutoComplete
                          dataSource={this.getOptions()}
                          onSearch={handleSpecialitySearch}
                          optionLabelProp="label"
                        />
                      )}
                    </FormItem>
                  </Col>
                </Row>

                <Row>
                  <Col span={24}>
                    <FormItem label={strings.profile.bio}>
                      {getFieldDecorator("bio", {
                        initialValue: profileDetail.bio,
                        valuePropName: "value"
                      })(<TextArea rows={3} />)}
                    </FormItem>
                  </Col>
                </Row>
                <div />

                <Row type="flex" justify="end" align="top">
                  <Col span={20}>
                    <Row type="flex" gutter={8}>
                      <Col span={3}>
                        <div className="verify-heading">
                          {strings.ticket_detail_view.VerifyStatus}:
                        </div>
                      </Col>

                      <Col span={21}>
                        <div className="verify-content">
                          {profileDetail.verified
                            ? `${strings.ticket_detail_view.Verified}`
                            : `${strings.ticket_detail_view.NotVerified}`}
                        </div>
                      </Col>
                    </Row>
                    {profileDetail.verified && (
                      <div>
                        <Row type="flex" gutter={8}>
                          <Col span={3}>
                            <div className="verify-heading">
                              {strings.ticket_detail_view.VerifiedBy}:
                            </div>
                          </Col>

                          <Col span={21}>
                            <div className="verify-content">
                              {profileDetail.verified_by_name}
                            </div>
                          </Col>
                        </Row>
                        <Row type="flex" gutter={8}>
                          <Col span={3}>
                            <div className="verify-heading">
                              {strings.ticket_detail_view.VerifiedAt}:
                            </div>
                          </Col>
                          <Col span={21}>
                            <div className="verify-content">
                              {moment(profileDetail.verified_at).format(
                                "DD MMM, YYYY"
                              )}
                            </div>
                          </Col>
                        </Row>
                        <Row type="flex" gutter={8}>
                          <Col span={3}>
                            <div className="verify-heading">
                              {strings.ticket_detail_view.VerifyReason}:
                            </div>
                          </Col>

                          <Col span={21}>
                            <div className="verify-content">
                              {profileDetail.verification_reason}
                            </div>
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Col>

                  <Col span={4} className="text-right">
                    <Button htmlType="submit" type="primary" size="small">
                      {strings.ticket_detail_view.save}
                    </Button>

                    {/* <Button
                      type="default"
                      onClick={goToNextTab}
                      size="small"
                      className="ml-8"
                    >
                      {strings.profile.next}
                    </Button> */}
                  </Col>
                </Row>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}
